// 系统管理导航与 URL 规则。保持这里不引入页面组件，方便菜单、跳转和测试复用纯路由元数据。
export const SYSTEM_MANAGEMENT_ROOT_PATH = '/system-management';

export const SYSTEM_MANAGEMENT_GROUPS = Object.freeze({
  ACCOUNT: 'account',
  JIANYING: 'jianying',
  VIDEO_EDITING: 'video-editing',
  VIDEO_TYPES: 'video-types',
});

export const SYSTEM_MANAGEMENT_SECTIONS = Object.freeze({
  ADD_ACCOUNT: 'add',
  ACCOUNTS: 'list',
  JIANYING_DEVICES: 'devices',
  JIANYING_TEMPLATES: 'templates',
  MATERIALS: 'materials',
  MATERIAL_CATEGORIES: 'material-categories',
  TEMPLATES: 'templates',
  VIDEO_TYPES: 'list',
});

export const SYSTEM_MANAGEMENT_MENU_GROUPS = [
  {
    group: SYSTEM_MANAGEMENT_GROUPS.JIANYING,
    title: '剪映',
    items: [
      {
        section: SYSTEM_MANAGEMENT_SECTIONS.JIANYING_TEMPLATES,
        label: '剪映模板',
        icon: 'bi-film',
      },
      {
        section: SYSTEM_MANAGEMENT_SECTIONS.JIANYING_DEVICES,
        label: '剪映设备',
        icon: 'bi-pc-display',
      },
    ],
  },
  {
    group: SYSTEM_MANAGEMENT_GROUPS.VIDEO_EDITING,
    title: '阿里云',
    items: [
      {
        section: SYSTEM_MANAGEMENT_SECTIONS.MATERIALS,
        label: '素材库',
        icon: 'bi-images',
      },
      {
        section: SYSTEM_MANAGEMENT_SECTIONS.MATERIAL_CATEGORIES,
        label: '分类管理',
        icon: 'bi-tags',
      },
      {
        section: SYSTEM_MANAGEMENT_SECTIONS.TEMPLATES,
        label: '模板管理',
        icon: 'bi-camera-reels',
      },
    ],
  },
  {
    group: SYSTEM_MANAGEMENT_GROUPS.VIDEO_TYPES,
    title: '视频类型',
    items: [
      {
        section: SYSTEM_MANAGEMENT_SECTIONS.VIDEO_TYPES,
        label: '视频标准配置',
        icon: 'bi-sliders',
      },
    ],
  },
  {
    group: SYSTEM_MANAGEMENT_GROUPS.ACCOUNT,
    title: '账户管理',
    items: [
      {
        section: SYSTEM_MANAGEMENT_SECTIONS.ACCOUNTS,
        label: '所有账户',
        icon: 'bi-people',
      },
    ],
  },
];

const getRouteKey = (group, section) => `${group}/${section}`;

const MENU_ROUTE_KEYS = SYSTEM_MANAGEMENT_MENU_GROUPS.flatMap((group) =>
  group.items.map((item) => [group.group, item.section]),
);

const EXTRA_ROUTE_KEYS = [
  [SYSTEM_MANAGEMENT_GROUPS.ACCOUNT, SYSTEM_MANAGEMENT_SECTIONS.ADD_ACCOUNT],
];

const ROUTE_KEY_SET = new Set(
  [...MENU_ROUTE_KEYS, ...EXTRA_ROUTE_KEYS].map(([group, section]) =>
    getRouteKey(group, section),
  ),
);

const DEFAULT_SECTION_GROUP = new Map(
  SYSTEM_MANAGEMENT_MENU_GROUPS.flatMap((group) =>
    group.items.map((item) => [item.section, group.group]),
  ),
);

DEFAULT_SECTION_GROUP.set(
  SYSTEM_MANAGEMENT_SECTIONS.ACCOUNTS,
  SYSTEM_MANAGEMENT_GROUPS.ACCOUNT,
);
DEFAULT_SECTION_GROUP.set(
  SYSTEM_MANAGEMENT_SECTIONS.ADD_ACCOUNT,
  SYSTEM_MANAGEMENT_GROUPS.ACCOUNT,
);

export const DEFAULT_SYSTEM_MANAGEMENT_GROUP =
  SYSTEM_MANAGEMENT_MENU_GROUPS.find((group) => group.items.length > 0)?.group;

export const DEFAULT_SYSTEM_MANAGEMENT_SECTION =
  SYSTEM_MANAGEMENT_MENU_GROUPS.find((group) => group.items.length > 0)
    ?.items[0]
    ?.section;

export const getSystemManagementSectionPath = (
  section,
  group = DEFAULT_SECTION_GROUP.get(section),
) => {
  const routeKey = getRouteKey(group, section);

  if (!ROUTE_KEY_SET.has(routeKey)) {
    return SYSTEM_MANAGEMENT_ROOT_PATH;
  }

  return `${SYSTEM_MANAGEMENT_ROOT_PATH}/${group}/${section}`;
};

export const DEFAULT_SYSTEM_MANAGEMENT_PATH = getSystemManagementSectionPath(
  DEFAULT_SYSTEM_MANAGEMENT_SECTION,
  DEFAULT_SYSTEM_MANAGEMENT_GROUP,
);

export const getSystemManagementRouteFromPathname = (pathname = '') => {
  const [root, group, section] = String(pathname).split('/').filter(Boolean);
  const fallbackRoute = {
    group: DEFAULT_SYSTEM_MANAGEMENT_GROUP,
    section: DEFAULT_SYSTEM_MANAGEMENT_SECTION,
  };

  if (
    root !== SYSTEM_MANAGEMENT_ROOT_PATH.slice(1) ||
    !group ||
    !section ||
    !ROUTE_KEY_SET.has(getRouteKey(group, section))
  ) {
    return fallbackRoute;
  }

  return { group, section };
};
